import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import CustomLoader from '../common/CustomLoader';
import { inviteTeamValidationSchema } from '../common/utils/form-validation';

export class InviteTeamMember extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  async componentDidMount() {
    const { home, actions } = this.props;
    const { project } = home;
    const { uuid } = project ? project : {};
    await actions.fetchProject({ projectId: uuid });
  }

  handleSubmit = async (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    try {
      const { email, isReadOnly } = values;

      const { home, actions } = this.props;
      const { project } = home;
      const { uuid } = project || {};

      await actions.inviteTeamMember({
        projectId: uuid,
        email,
        isReadOnly,
      });

      await actions.teamMemberPendingRequests();

      resetForm();
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setSubmitting(false);
    }
  };

  render() {
    const { home } = this.props;
    const { inviteTeamMemberPending } = home;
    return (
      <div className="card bg-white mb-3">
        <div className="card-header">
          <h4>Invite Team Member</h4>
        </div>
        <hr className="dark horizontal " style={{ marginTop: '-12px' }} />
        <Formik
          initialValues={{ email: '', isReadOnly: false }}
          validationSchema={inviteTeamValidationSchema}
          onSubmit={this.handleSubmit}
        >
          {({ isSubmitting, touched, errors }) => (
            <Form>
              <div className="card-body">
                <div className="row">
                  <div className="col">
                    <div className="form-group">
                      <label className="col-form-label">Email</label>
                      <Field
                        type="text"
                        name="email"
                        placeholder="Email"
                        className={`form-control ${
                          touched.email && errors.email ? 'is-invalid' : ''
                        }`}
                        style={{
                          border: '1px solid #ced4da',
                          borderRadius: '0.25rem',
                          padding: '0.375rem 0.75rem',
                        }}
                      />
                      <ErrorMessage name="email" component="div" className="invalid-feedback" />
                    </div>
                    <div className="form-check mt-3 p-0">
                      <Field
                        type="checkbox"
                        name="isReadOnly"
                        className="form-check-input"
                        id="isReadOnly"
                      />
                      <label className="form-check-label" htmlFor="isReadOnly">
                        Read-Only Access
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer d-flex justify-content-end">
                <button
                  type="submit"
                  className="btn btn-success btn-md text-white custom-submit-button"
                  disabled={isSubmitting || inviteTeamMemberPending}
                >
                  <i className="material-icons text-lg position-relative">person_add</i> Invite
                  <CustomLoader loading={isSubmitting || inviteTeamMemberPending} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InviteTeamMember);
